import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { bool, func, string, oneOfType, arrayOf, node } from "prop-types";
import cx from "classnames";
import Button from "@ingka/button";
import cross from "@ingka/ssr-icon/paths/cross";
import arrowBack from "@ingka/ssr-icon/paths/arrow-left";
const propTypes = {
  closeBtnClick: func,
  /** Prefix all classes in every element with this string [Inherited] */
  prefix: string,
  /** Additional class name to be added to the root element */
  className: string,
  /** Renders the value as title in the header. */
  title: string,
  /** Text read for screen readers on close button in header [Inherited] */
  ariaCloseTxt: string,
  /** Text read for screen readers on black button in header */
  ariaBackBtnTxt: string,
  /** Adds a back button and it's callback to the header. */
  backBtnClick: func,
  /** Enables a backgroundless floating header mode. Ignores title prop */
  floating: bool,
  /** Sets HTML id attribute on `title` propType's HTML tag */
  titleId: string,
  children: oneOfType([
    arrayOf(node),
    node
  ])
};
const ModalHeader = (props) => {
  const {
    title,
    titleId,
    prefix = "",
    className,
    closeBtnClick,
    ariaCloseTxt = "Close",
    backBtnClick,
    ariaBackBtnTxt = "Back",
    floating = false,
    children,
    ...other
  } = props;
  const wrapperClasses = cx(
    `${prefix}modal-header__title-wrapper`,
    !backBtnClick && `${prefix}modal-header__title-wrapper--padded`
  );
  const headerClasses = cx(
    `${prefix}modal-header`,
    floating && `${prefix}modal-header--floating-header`,
    className
  );
  return /* @__PURE__ */ jsxs("div", { className: headerClasses, ...other, children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        prefix,
        type: "primary",
        inverseTheme: true,
        small: true,
        iconOnly: true,
        ssrIcon: cross,
        onClick: closeBtnClick,
        className: `${prefix}modal-header__close`,
        "aria-label": ariaCloseTxt
      }
    ),
    !floating && (title || children) && /* @__PURE__ */ jsxs("div", { className: wrapperClasses, children: [
      title && /* @__PURE__ */ jsx("h2", { id: titleId, className: `${prefix}modal-header__title`, children: title }),
      children
    ] }),
    backBtnClick && /* @__PURE__ */ jsx(
      Button,
      {
        prefix,
        type: "primary",
        inverseTheme: true,
        small: true,
        iconOnly: true,
        ssrIcon: arrowBack,
        onClick: backBtnClick,
        className: `${prefix}modal-header__back-button`,
        "aria-label": ariaBackBtnTxt
      }
    )
  ] });
};
ModalHeader.propTypes = propTypes;
ModalHeader.displayName = "ModalHeader";
var Header_default = ModalHeader;
export {
  Header_default as default
};
